<template>
  <oie-base-button
    v-show="!hidden"
    is-type="button"
    :css-classes="['button-link jump-to-top']"
    :aria-label="tStatic('jumpToTop')"
    @click="goToTop"
    @touchstart.native="goToTop">
    <template #icon>
      <oie-use-svg
        svg="caret"
        height="35"
        width="35"
        class="svg--90-negative"></oie-use-svg>
    </template>
  </oie-base-button>
</template>

<script>
import _ from 'lodash'
export default {
  data() {
    return {
      hidden: true
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: _.debounce(function() {
      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode
      if(!isIE11) {
        if(window.scrollY > 250) {
          this.hidden = false
        } else {
          this.hidden = true
        }
      }
    }, 100),
    goToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }

}
</script>

<style lang="scss">
.jump-to-top {
  position: fixed;
  bottom: calc(1.25rem + env(safe-area-inset-bottom));;
  left: 0.625rem;
  height:auto;
  padding: measure(eighth);
  z-index: 999;
  transition: none;

  @include media(target-ie) {
    visibility: hidden;
  }
}

:has(#CookiebotWidget) .jump-to-top {
  bottom: calc(1.25rem + 3rem + env(safe-area-inset-bottom));
}

</style>
